/* Tikadeau — swap d'image au hover sur les cards produit (collection,
   homepage, recherche). Au premier survol d'une card, fetch lazy de
   /products/<handle>.js pour récupérer la 2e image, qui est ajoutée
   comme overlay et révélée par CSS sur :hover.
   Cache mémoire par handle → aucun fetch supplémentaire. */
(function () {
  if (!window.fetch) return;

  var cache = {};

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function getPrimaryImg(card) {
    var imgs = card.querySelectorAll('img');
    // Prend la première image principale, pas un swatch / icône
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var r = img.getBoundingClientRect();
      if (r.width >= 100 && r.height >= 100) return img;
    }
    return imgs[0] || null;
  }

  function setupCard(card) {
    if (card.dataset.tkHoverInit) return;
    card.dataset.tkHoverInit = '1';

    var primary = getPrimaryImg(card);
    if (!primary || !primary.parentNode) return;

    var handle = getHandle(card);
    if (!handle) return;

    var hoverImg = null;
    var fetched = false;

    function fetchAndInject() {
      if (fetched) return;
      fetched = true;
      if (cache[handle] === undefined) {
        cache[handle] = fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });
      }
      cache[handle].then(function (data) {
        if (!data || !data.images || data.images.length < 2) return;
        if (hoverImg) return;
        hoverImg = primary.cloneNode(false);
        hoverImg.src = data.images[1];
        hoverImg.removeAttribute('srcset');
        hoverImg.removeAttribute('sizes');
        hoverImg.className = 'tk-hover-img';
        hoverImg.loading = 'lazy';
        hoverImg.alt = '';
        hoverImg.setAttribute('aria-hidden', 'true');
        primary.parentNode.classList.add('tk-hover-img-parent');
        primary.parentNode.appendChild(hoverImg);
      });
    }

    card.addEventListener('mouseenter', fetchAndInject, { passive: true });
    // Touchstart pour mobile/tablette aussi (peu utile mais inoffensif)
    card.addEventListener('touchstart', fetchAndInject, { passive: true });
  }

  function init() {
    document.querySelectorAll('product-card, .product-card, .resource-card').forEach(setupCard);
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        document.querySelectorAll('product-card:not([data-tk-hover-init]), .product-card:not([data-tk-hover-init]), .resource-card:not([data-tk-hover-init])').forEach(setupCard);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
